export const strokeSolidIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2 9v2h16V9z"/></svg>`,
  name: 'stroke-solid',
};
